import { render } from "./RestaurantOrderList.vue?vue&type=template&id=db98fe1c"
import script from "./RestaurantOrderList.vue?vue&type=script&lang=js"
export * from "./RestaurantOrderList.vue?vue&type=script&lang=js"

import "./RestaurantOrderList.vue?vue&type=style&index=0&id=db98fe1c&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__